import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCalendarTearOff: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"calendar-tear-off, date"} maskId="square-filled-radius-0-stroke-1-IconCalendarTearOff"><path d="M7 2H8V4H16V2H17V4H21V6.76421L18.3405 7.51945L14.4799 6.96985L13.4736 7.97267L10.9531 6.96796L7.73539 8.03681L3 6.75305V4H7V2Z" fill="currentColor"/><path d="M3 7.78915V21H21V7.80375L18.4095 8.53938L14.8326 8.03015L13.7139 9.14498L10.9219 8.03205L7.76461 9.08084L3 7.78915Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconCalendarTearOff;
